module.exports = __webpack_public_path__ + "media/react/assets/Comment2-6836f48fb83264598f6a24a59d1dce5e.svg";